import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { StickyCTA } from './components/StickyCTA';
import { Hero } from './components/Hero';
import { Promesa } from './components/Promesa';
import { Mecanismo } from './components/Mecanismo';
import { Bonus } from './components/Bonus';
import { Oferta } from './components/Oferta';
import { Garantia } from './components/Garantia';
import { Testimonios } from './components/Testimonios';
export function App() {
  return <div className="min-h-screen bg-[#faf9f6] font-sans selection:bg-[#0f4c5c] selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Promesa data-id="element-4" />
        <Mecanismo data-id="element-5" />
        <Bonus data-id="element-6" />
        <Oferta data-id="element-7" />
        <Garantia data-id="element-8" />
        <Testimonios data-id="element-9" />
      </main>

      <PurchasePopup data-id="element-10" />
      <StickyCTA data-id="element-11" />
    </div>;
}